import {computed} from "vue";
import {store} from "@/store/store";
import { SCREEN_LG_START, SCREEN_XL_START, SCREEN_MEDIUM_START, SCREEN_SMALL_START } from "@/utilities/constants";

export default function useScreenSize() {

    const screenWidth = computed(() => {
        return store.state.app.screenWidth;
    });

    const screenHeight = computed(() => {
        return store.state.app.screenHeight;
    });

    function reportWindowSize() {
        store.commit("app/setScreenSize", {
            width: window.innerWidth,
            height: window.innerHeight
        });
    }

    /**
     * Call this function once, e.g. in App.vue
     */
    function mountMe() {
        reportWindowSize();
        window.addEventListener('resize', reportWindowSize);
    }

    function unmountMe() {
        window.removeEventListener('resize', reportWindowSize);
    }


    const currentWidthType = computed(() => {
        if (screenWidth.value >= 1400) {

            return 'xl';
        }
        if (screenWidth.value >= 1024) {
            return 'lg';
        }
        return 'tbd';
    })

    const screenTypes = {
        SCREEN_LG_START,
        SCREEN_XL_START,
        SCREEN_MEDIUM_START,
        SCREEN_SMALL_START
    }

    const isMinLarge = computed(() => {
        return screenWidth.value >= screenTypes.SCREEN_LG_START
    })

    const isMinMedium = computed(() => {
        return screenWidth.value >= screenTypes.SCREEN_MEDIUM_START
    })

    const isMaxMedium = computed(() => {
        return screenWidth.value < screenTypes.SCREEN_LG_START
    })

    const isMaxSmall = computed(() => {
        return screenWidth.value < screenTypes.SCREEN_MEDIUM_START
    })
    const isMaxXSmall = computed(() => {
        return screenWidth.value < screenTypes.SCREEN_SMALL_START
    })



    return {
        mountMe,
        unmountMe,
        screenWidth,
        screenHeight,
        currentWidthType,
        screenTypes,
        isMinLarge,
        isMaxMedium,
        isMinMedium,
        isMaxSmall,
        isMaxXSmall
    }

}